import { TariffsManagement } from 'pages/tariffs';

import { Unauthorized } from 'components/unauthorized';

import { useCanAccess } from 'hooks/useCanAccess';
import { TokenExpired } from 'components/tokenExpired';

export const TariffManagementRoute = () => {
  const { isAdmin, isExpired } = useCanAccess('tariffs');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <TariffsManagement />
  ) : (
    <Unauthorized />
  );
};
